import { observer } from 'mobx-react';
import { Grid } from '@material-ui/core';
import { ManualQuoteDisclaimerCard } from '../components/cards/manualQuoteDisclaimerCard';
import ManualQuoteLogCard from '../components/cards/manualQuoteLogCard';
import { ManualQuoteTermCard } from '../components/cards/manualQuoteTermsCard';
import { ManualQuoteSummaryCard } from '../components/bridge/manualQuoteSummaryCard';
import { useEffect } from 'react';
import { useManualQuoteStore } from '@roc/feature-loans';
import { Document } from '@roc/feature-types';

interface LoanPricingTabProps {
  source: 'nportal' | 'cportal';
  document?: Document;
}

export const ManualQuoteTab = observer(({ source, document }: LoanPricingTabProps) => {

  const { manualQuoteStore } = useManualQuoteStore();

  useEffect(() => {
    manualQuoteStore.portal = source;
  }, []);

  return (
    <>
      <Grid item xs={12} style={{ marginBottom: 20 }}>
        <ManualQuoteSummaryCard />
      </Grid>
      <Grid item xs={12} style={{ marginBottom: 20 }}>
        <ManualQuoteTermCard document={document} />
      </Grid>
      <Grid item xs={12} style={{ marginBottom: 20 }}>
        <ManualQuoteLogCard fullHeight />
      </Grid>
    </>
  );
});
